export class WebhookEventTypes {
  eventTypes: string[];
}
